import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IUser } from 'app/shared/model/user.model';
import { IPlace } from 'app/shared/model/place.model';

export interface IMaintenanceVehicle {
  id?: number;
  code?: string | null;
  serviceOrder?: string | null;
  created?: string | null;
  km?: number | null;
  age?: number | null;
  hour?: number | null;
  proofContentType?: string | null;
  proof?: string | null;
  objectKey?: string | null;
  description?: string | null;
  manual?: boolean | null;
  blocked?: boolean | null;
  reviewOrder?: number | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
  place?: IPlace | null;
  planned?: boolean | null;
}

export const defaultValue: Readonly<IMaintenanceVehicle> = {
  manual: false,
  blocked: false,
};
